import { ArrowPathIcon, ChartBarIcon, HomeIcon } from '@heroicons/react/24/outline';

import { Sidebar } from '@/components/layout/Sidebar';
import { CanvasRoutes, RouterConfig, Routes } from '@/configs/routes';

const items = Routes.filter((r) => r.showInNavigation && r.path.startsWith('/overview/'));

const iconMap = {
  [RouterConfig[CanvasRoutes.OverviewHome].path]: HomeIcon,
  [RouterConfig[CanvasRoutes.OverviewCycle].path]: ArrowPathIcon,
  [RouterConfig[CanvasRoutes.OverviewPerformance].path]: ChartBarIcon,
};

export function OverviewSidebar() {
  return items.length > 0 ? <Sidebar label="Overview" items={items} iconMap={iconMap} depth={1} /> : null;
}
